// Only the "signed copy received" checkbox: the signature itself is not part of this form yet.
// Checking it with answers missing is refused by the form hook, which points to them.
const buildSignature = ({ isLocked }) => ({
  name: 'signature',
  title: 'SIGNATURE',
  titleVariant: 'subsection',
  divider: true,
  container: 'default',
  disabled: isLocked,
  fields: [
    {
      variant: 'checkbox',
      name: 'hasSignedCopy',
      label:
        "We have received a signed copy of this applicant's lease application.",
      disabled: isLocked,
      GridProps: { xs: 12 },
    },
  ],
});

export default buildSignature;
